<template>
  <div
    class="fixed w-full h-full flex justify-center items-center bg-overlay z-50 top-0 left-0"
  >
    <AddNewCardModal
      v-if="showAddNewCardModal"
      :error="error"
      @close="toggleAddNewCard"
      @card-added="addedNewCard"
    />
    <div
      class="relative flex flex-col w-auto m-[20px] xl:m-0 xl:w-[1048px] h-fit rounded bg-white overflow-hidden"
    >
      <!-- intro -->
      <div
        class="relative flex flex-row justify-start custom-820:p-4 p-4 xl:p-[54px] bg-primary-700"
      >
        <!-- close btn -->
        <button
          class="absolute left-2 top-5 xl:left-[25px] xl:top-[27px] w-9 h-9 rounded flex justify-center items-center text-white"
          @click="closeModal"
        >
          <span class="material-symbols-rounded">close</span>
        </button>
        <!-- sale title -->
        <div class="flex flex-row gap-[20px]">
          <div
            class="flex justify-center items-center h-[40px] w-[40px] bg-complementary-600 text-complementary-900 rounded-full"
          >
            <span class="material-symbols-rounded">storefront</span>
          </div>
          <h2 class="font-medium text-2xl text-white">תשלום חוב</h2>
        </div>
      </div>
      <!-- content -->
      <div
        v-if="loading"
        class="text-primary-300 text-2xl w-full font-bold flex items-center justify-center custom-820:h-auto h-auto xl:h-[550px]"
      >
        מעדכן נתונים...
      </div>
      <div
        v-else-if="paymentUnsuccessful"
        class="custom-480:h-[150px] h-[320px] custom-820:overflow-y-scroll custom-820:min-h-auto overflow-y-scroll xl:overflow-y-auto xl:h-auto xl:min-h-[550px] flex items-center justify-center flex-col gap-1"
      >
        <span class="material-symbols-rounded text-error text-4xl">ביטול</span>
        <div class="text-primary-300 text-2xl">
          {{ errorText ? errorText : "התשלום לא הצליח" }}
        </div>
        <div class="mt-5 text-grays-500 text-xl">בבקשה נסה שוב</div>
        <button-primary class="mt-14" @click="togglePaymentUnsuccessful"
          >שלם חוב
        </button-primary>
      </div>
      <div
        v-else-if="paymentSuccessful"
        class="custom-480:h-[150px] h-[320px] overflow-y-scroll xl:overflow-y-auto xl:h-auto xl:min-h-[550px] flex items-center justify-center flex-col gap-1"
      >
        <span
          class="w-10 h-10 flex items-center justify-center material-symbols-rounded text-white text-4xl rounded-full bg-success"
          >check</span
        >
        <div class="text-primary-300 text-2xl">The payment was successful!</div>
      </div>
      <div
        v-else
        class="flex flex-col custom-820:pt-4 custom-820:pb-4 px-4 xl:px-[60px] gap-4 xl:gap-[40px] pt-4 xl:pt-[73px] pb-4 xl:pb-[40px] custom-480:h-[150px] h-[320px] overflow-y-scroll xl:overflow-y-auto xl:h-auto xl:min-h-[550px]"
      >
        <!-- intro -->
        <h3
          class="text-sm lg:text-xl text-grays-900 font-medium p-0 xl:p-0 xl:pl-[250px]"
        >
          כדי שתוכלו להמשיך להשתמש ולהזמין במערכת המכירות
          <br />
          שלמו את החוב שלכם ונוכל להמשיך.
        </h3>
        <!-- debts section -->
        <div class="flex flex-col gap-[12px]">
          <!-- debt -->
          <div
            v-for="debt in debts"
            :key="debt.id"
            class="flex flex-row items-center xl:justify-between gap-2 xl:gap-[36px]"
          >
            <check-box v-model="debt.selected"></check-box>
            <!-- content -->
            <div
              class="lg:flex flex-row pl-[28px] py-[11px] border-b border-grays-400"
            >
              <div class="lg:flex flex-row gap-[26px] items-center">
                <div
                  class="flex flex-none flex-row items-center w-[196px] gap-[8px]"
                >
                  <div
                    class="h-[28px] w-[28px] rounded-full bg-complementary-600 flex-none flex items-center justify-center p-[7px]"
                  >
                    <icon-mishnat />
                  </div>
                  <div class="w-[152px] flex flex-col">
                    <p
                      class="text-lg text-complementary-900 font-bold overflow-hidden truncate"
                      :title="debtTitle(debt)"
                    >
                      {{ debtTitle(debt) }}
                    </p>
                    <p
                      class="text-xs text-complementary-900 font-regular mt-[-5px]"
                    >
                      {{ debt.order ? "המכירה השבועית" : "חוב במערכת" }}
                    </p>
                  </div>
                </div>
                <!-- order debt: order date, pickup date, order number -->
                <div v-if="debt.order" class="md:flex flex-row gap-[10px]">
                  <div class="flex flex-none flex-col w-[170px]">
                    <p class="text-sm font-medium text-grays-600">
                      תאריך הזמנה
                    </p>
                    <p class="text-base font-regular text-grays-900">
                      {{ moment(debt.order.time).format("dddd") }}
                    </p>
                    <p class="text-base font-regular text-grays-900">
                      {{ jDate(debt.order.time) }}
                      {{ moment(debt.order.time).format("DD/MM/Y") }}
                    </p>
                  </div>
                  <div
                    v-if="debt.order.sale && debt.order.sale.supply_begin"
                    class="flex flex-none flex-col w-[170px]"
                  >
                    <p class="text-sm font-medium text-grays-600">
                      תאריך איסוף
                    </p>
                    <p class="text-base font-regular text-grays-900">
                      {{ moment(debt.order.sale.supply_begin).format("dddd") }}
                    </p>
                    <p class="text-base font-regular text-grays-900 flex">
                      {{ jDate(debt.order.sale.supply_begin) }}
                      {{
                        moment(debt.order.sale.supply_begin).format("DD/MM/Y")
                      }}
                    </p>
                  </div>
                  <div class="flex flex-none flex-col w-[140px]">
                    <p class="text-sm font-medium text-grays-600">מספר הזמנה</p>
                    <p class="text-base font-regular text-grays-900">
                      {{ debt.order.id }}
                    </p>
                  </div>
                </div>
                <!-- general debt (created without an order): debt date + description -->
                <div v-else class="md:flex flex-row gap-[10px]">
                  <div class="flex flex-none flex-col w-[170px]">
                    <p class="text-sm font-medium text-grays-600">
                      תאריך החוב
                    </p>
                    <p class="text-base font-regular text-grays-900">
                      {{ moment(debtDate(debt)).format("dddd") }}
                    </p>
                    <p class="text-base font-regular text-grays-900">
                      {{ jDate(debtDate(debt)) }}
                      {{ moment(debtDate(debt)).format("DD/MM/Y") }}
                    </p>
                  </div>
                  <div class="flex flex-none flex-col w-[310px]">
                    <p class="text-sm font-medium text-grays-600">פירוט</p>
                    <p class="text-base font-regular text-grays-900">
                      {{ debt.for }}
                    </p>
                  </div>
                </div>
              </div>
              <!-- action -->
              <div class="flex flex-row flex-none gap-[8px] items-center">
                <div class="flex flex-row justify-end gap-[4px]">
                  <span
                    class="material-symbols-rounded text-primary-700 text-base"
                    >payments</span
                  >
                  <p class="text-primary-700 text-base font-regular">
                    סך הכל: ₪ {{ debt.skum }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- payment options -->
        <div
          class="lg:flex flex-row justify-between items-center border border-grays-400 rounded bg-gray_semantic py-[14px] px-[21px]"
        >
          <div class="lg:flex flex-row justify-start items-center gap-[32px]">
            <h3 class="text-xl text-primary-700 font-medium">
              בחר כרטיס אשראי
            </h3>
            <form
              class="flex flex-row justify-between items-center gap-[12px]"
              type="submit"
            >
              <div v-if="creditCards.length" class="flex flex-col gap-[4px]">
                <label class="text-grays-700 text-sm font-regular"
                  >תשלומים</label
                >
                <select-payment
                  :add-card-modal="true"
                  :credit-cards="creditCards"
                  :current-card="creditCards[0]"
                  :openUp="true"
                  @add-new-card="toggleAddNewCard"
                  @card-changed="changeCard"
                />
              </div>
              <div v-else class="text-error">
                אין כרטיס אשראי מעודכן בחשבונכם
                <router-link :to="'/payment-methods'" class="text-primary-900"
                  >להוספת פרטי אשראי</router-link
                >
              </div>
              <!--              <div class="flex flex-col gap-[4px]">-->
              <!--                <label class="text-grays-700 text-sm font-regular"-->
              <!--                >תשלומים</label-->
              <!--                >-->
              <!--                <select-number :current-payments="1" :max-number="9" :openUp="true"-->
              <!--                               @payment-changed="changePaymentNumber"/>-->
              <!--              </div>-->
            </form>
          </div>
          <h3 class="text-xl text-primary-700 font-medium">
            סה”כ לתשלום:
            <span class="font-bold">
              {{
                debts
                  .filter((debt) => debt.selected)
                  .reduce((acc, item) => (acc += item.skum), 0)
              }}
              ש”ח</span
            >
          </h3>
        </div>
      </div>
      <!-- action -->
      <div
        v-if="!paymentUnsuccessful"
        class="flex flex-row justify-end gap-2 xl:gap-[32px] py-4 xl:py-[25px] pl-4 xl:pl-[43px] border-t border-grays-400"
      >
        <button-primary
          v-if="paymentSuccessful && this.debts.length"
          @click="togglePaymentSuccessful"
        >
          continue to other debts
        </button-primary>
        <button-primary
          v-else-if="paymentSuccessful && !this.debts.length"
          @click="closeModal"
        >
          close
        </button-primary>
        <button-primary
          v-else
          :disabled="!hasSelectedDebt || processingRequest"
          @click="payDebts"
        >
          {{ processingRequest ? "מעדכן נתונים..." : "שלם חוב" }}
        </button-primary>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonPrimary from "@/components/Global/ButtonPrimary.vue";
import SelectPayment from "@/components/Global/SelectPayment.vue";
import SelectNumber from "@/components/Global/SelectNumber.vue";
import IconMishnat from "@/components/Global/IconMishnat.vue";
import CheckBox from "@/components/Global/CheckBox.vue";
import { mapActions, mapMutations } from "vuex";
import moment from "moment";
import "moment/locale/he";
import dayjs from "dayjs";
import hebrewDate from "hebrew-date";
import axiosInstance from "@/helpers/axios";
import AddNewCardModal from "@/components/Modals/AddNewCardModal.vue";

export default {
  name: "pay-debt-modal",
  components: {
    AddNewCardModal,
    CheckBox,
    IconMishnat,
    SelectNumber,
    SelectPayment,
    ButtonPrimary,
  },
  data() {
    return {
      creditCards: [],
      selectedCard: {},
      showAddNewCardModal: false,
      error: "",
      paymentUnsuccessful: false,
      errorText: "",
      paymentSuccessful: false,
      debts: [],
      loading: false,
      processingRequest: false,
    };
  },
  methods: {
    ...mapMutations({
      setDebts: "debtsModule/setDebts",
    }),
    async addedNewCard(cardDetails) {
      if (!cardDetails.saveCard) {
        try {
          const response = await axiosInstance.post("/check_card", {
            cardMonth: cardDetails.save_tokef.split("/")[0],
            cardYear: "20" + cardDetails.save_tokef.split("/")[1],
            cardNumber: cardDetails.save_card,
          });
          const token = response.data.token;
          this.creditCards.push({
            token,
            cardMonth: cardDetails.save_tokef.split("/")[0],
            cardYear: cardDetails.save_tokef.split("/")[1],
            temporary: true,
          });
          this.toggleAddNewCard();
        } catch (e) {
          this.error = e.response.data.message;
          console.error(e);
        }
      }
    },
    toggleAddNewCard() {
      this.showAddNewCardModal = !this.showAddNewCardModal;
    },
    togglePaymentUnsuccessful() {
      this.paymentUnsuccessful = !this.paymentUnsuccessful;
    },
    togglePaymentSuccessful() {
      this.paymentSuccessful = !this.paymentSuccessful;
    },
    changeCard(card) {
      this.selectedCard = card;
    },
    closeModal() {
      this.toggleDebtsModal();
    },
    ...mapActions({
      toggleDebtsModal: "debtsModule/toggleIsModalVisible",
      showToast: "orderToast/showToast",
    }),
    async payDebts() {
      this.errorText = "";
      this.processingRequest = true;
      try {
        if (this.selectedCard.temporary) {
          await axiosInstance.post("/pay_debts", {
            cardMode: "newCard",
            card: this.selectedCard,
            debts: this.debts
              .filter((item) => item.selected)
              .map((item) => {
                return {
                  ...item,
                  checked: true,
                };
              }),
          });
        } else {
          await axiosInstance.post("/pay_debts", {
            card_id: this.selectedCard.id,
            debts: this.debts
              .filter((item) => item.selected)
              .map((item) => {
                return {
                  ...item,
                  checked: true,
                };
              }),
          });
        }
        this.debts = this.debts.filter((item) => !item.selected);
        this.setDebts(this.debts);
        const user = JSON.parse(localStorage.getItem("user") || "{}");
        if (Object.keys(user).length === 0) {
          return;
        }
        user.debts = this.debts;
        localStorage.setItem("user", JSON.stringify(user));
        if (!this.debts.length) {
          this.closeModal();
        }
      } catch (e) {
        this.errorText = e.response.data.global_message;
        const arrayOfPayedDebts = e.response.data.responses
          .filter((item) => item.status === "success")
          .map((item) => item.debt_id);
        this.debts = this.debts.filter((item) =>
          arrayOfPayedDebts.includes(item.id)
        );
        this.setDebts(this.debts);

        this.paymentUnsuccessful = true;
      } finally {
        this.processingRequest = false;
      }
    },
    // Order debts are named after their sale. General debts (created in the
    // admin without an order, listID = 0, so `order` is null) are named after
    // the week they belong to, falling back to the admin's description.
    debtTitle(debt) {
      if (debt.order) {
        return this.$saleName(debt.order.sale) || debt.for || "חוב";
      }
      return (debt.parent && debt.parent.week) || debt.for || "חוב";
    },
    debtDate(debt) {
      return debt.date || debt.time || null;
    },
    moment: function (param1, param2) {
      return moment(param1, param2);
    },
    jDate: function (date) {
      const months = [
        "תשרי",
        "חשוון",
        "כסליו",
        "טבת",
        "שבט",
        "אדר א",
        "אדר ב",
        "ניסן",
        "אייר",
        "סיון",
        "תמוז",
        "אב",
        "אלול",
      ];
      const days = [
        "א",
        "ב",
        "ג",
        "ד",
        "ה",
        "ו",
        "ז",
        "ח",
        "ט",
        "י",
        "יא",
        "יב",
        "יג",
        "יד",
        "טו",
        "טז",
        "יז",
        "יח",
        "יט",
        "כ",
        "כא",
        "כב",
        "כג",
        "כד",
        "כה",
        "כו",
        "כז",
        "כח",
        "כט",
        "ל",
      ];
      const years = {
        5781: "תשפ״א",
        5782: "תשפ״ב",
        5783: "תשפ״ג",
        5784: "תשפ״ד",
        5785: "תשפ״ה",
        5786: "תשפ״ו",
        5787: "תשפ״ז",
        5788: "תשפ״ח",
      };
      if (!date || !dayjs(date).isValid()) {
        return "";
      }
      const y = Number(dayjs(date, "YYYY-MM-DD").format("YYYY"));
      const m = dayjs(date, "YYYY-MM-DD").format("M") - 1;
      const d = Number(dayjs(date, "YYYY-MM-DD").format("D"));
      const day = moment(date).format("dddd");

      return `${days[hebrewDate(new Date(y, m, d)).date - 1]} ${
        months[hebrewDate(new Date(y, m, d)).month - 1]
      }`;
    },
    async getCardsData() {
      const response = await axiosInstance.get("/payment_methods/cards");
      this.creditCards = response.data.filter((item) => item.type === "cc");
    },
    async getDebts() {
      const { data } = await axiosInstance.get("/profile");
      this.debts = data.debts;
    },
  },
  computed: {
    hasSelectedDebt() {
      return this.debts.some((debt) => debt.selected);
    },
    show() {
      return this.$store.state.payDebt.show;
    },
  },
  async mounted() {
    this.loading = true;
    try {
      await Promise.all([this.getDebts(), this.getCardsData()]);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      this.loading = false;
    }
  },
};
</script>

<style>
</style>